import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksRecomendedMachines: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES].GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES,
	},
}